const ADDRESS_MODEL = {
  addressees_name: null,
  city: null,
  country: null,
  full_address: null,
  house_name: null,
  house_number: null,
  id: null,
  lat: null,
  lng: null,
  postal_code: null,
  state: null,
  street: null
};

const USER_MODEL = {
  address: ADDRESS_MODEL,
  billingAddress: ADDRESS_MODEL,
  email: null,
  farms: null,
  first_name: null,
  full_address: null,
  geofences: null,
  id: null,
  is_email_notify_enabled: null,
  is_push_notify_enabled: null,
  last_name: null,
  notify_email: null,
  notify_phone: null,
  private_phone: null,
  profile_picture_url: null,
  work_phone: null
};

export const getEmptyUser = () => USER_MODEL;
